import { ProgressSpinner } from "primereact/progressspinner";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";

const View = () => {
  const [receiveData, setReceiveData] = useState({});
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await Http.get("/leave-application/" + id);
      setReceiveData(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <IsLogin />
      <div className="am-mainpanel">
        <div className="am-pagetitle d-flex justify-content-between align-items-center">
          <h5 className="am-title">Leave Application Detail</h5>
        </div>

        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40 shadow-sm rounded">
            {loading ? (
              <div className="text-center py-5">
                <ProgressSpinner />
                <p className="mt-3">Loading leave application details...</p>
              </div>
            ) : (
              <div>
                <div className="mb-4 border-bottom pb-3">
                  <h4 className="mb-2">
                    {receiveData.staff?.name || "N/A"}{" "}
                    <span className="badge badge-primary text-capitalize">
                      {receiveData.leave_type || "N/A"}
                    </span>
                  </h4>
                  <small className="text-muted">
                    Application Date: {receiveData.application_date || "N/A"}
                  </small>
                </div>

                <div className="row">
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">Start Date</h6>
                      <p className="mb-0">{receiveData.start_date || "N/A"}</p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">End Date</h6>
                      <p className="mb-0">{receiveData.end_date || "N/A"}</p>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">Total Days</h6>
                      <p className="mb-0">{receiveData.total_days || 0}</p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">Status</h6>
                      <span
                        className={`badge ${
                          receiveData.status === "approved"
                            ? "badge-success"
                            : receiveData.status === "pending"
                            ? "badge-warning"
                            : "badge-secondary"
                        }`}
                      >
                        {receiveData.status || "N/A"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">Recommended By</h6>
                      <p className="mb-0">
                        {receiveData.recommened_by?.name || "Not Recommended"}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">Approved By</h6>
                      <p className="mb-0">
                        {receiveData.approved_by?.name || "Not Approved"}
                      </p>
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="p-3 border rounded">
                      <h6 className="text-muted mb-1">Remarks</h6>
                      <p className="mb-0">
                        {receiveData.remarks || "No Remarks"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="text-right mt-4">
                  <button
                    className="btn btn-secondary"
                    onClick={() => window.history.back()}
                  >
                    Back
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default View;
